import React, { Component } from 'react';
import { AbstractIcon } from './AbstractIcon';
import { AbstractIconDefaultProps, AbstractIconPropTypes } from './utils';

export class MailIcon extends Component {
    static defaultProps = AbstractIconDefaultProps;
    static propTypes = AbstractIconPropTypes;

    render() {
        const props = this.props;

        return (
            <AbstractIcon viewBox="0 0 24 24" {...props}>
                <path d="M17.0975 9.37937L12.5923 12.0678C12.3151 12.2332 11.9745 12.2332 11.6972 12.0678L7.19746 9.38259M5.8 18.3886C4.80589 18.3886 4 17.5491 4 16.5136V7.13867C4 6.10314 4.80589 5.26367 5.8 5.26367H18.4C19.3941 5.26367 20.2 6.10314 20.2 7.13867V16.5136C20.2 17.0109 20.0103 17.4878 19.6728 17.8395C19.3352 18.1911 18.8773 18.3886 18.3999 18.3886L5.8 18.3886Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            </AbstractIcon>
        );
    }
}
